var _ref2, _ref3;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgVisible = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Group_18210",
      "data-name": "Group 18210",
      width: 25.11,
      height: 16.756,
      viewBox: "0 0 25.11 16.756",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("defs", null,
    /*#__PURE__*/
    React.createElement("clipPath", {
      id: "clip-path"
    },
    /*#__PURE__*/
    React.createElement("rect", {
      id: "Rectangle_81193",
      "data-name": "Rectangle 81193",
      width: 25.11,
      height: 16.756,
      transform: "translate(0 0)"
    })))), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_18209",
      "data-name": "Group 18209",
      clipPath: "url(#clip-path)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22439",
      "data-name": "Path 22439",
      d: "M12.555.01C3.451.336,0,8.38,0,8.38a15.042,15.042,0,0,0,12.555,8.376A13.538,13.538,0,0,0,25.11,8.386C20.224-.629,12.555.01,12.555.01M12.4,13.721a5.333,5.333,0,1,1,5.333-5.333A5.333,5.333,0,0,1,12.4,13.721"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22440",
      "data-name": "Path 22440",
      d: "M12.4,5.324a3.188,3.188,0,1,0,3.188,3.188A3.188,3.188,0,0,0,12.4,5.324"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgVisible, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Visible.9434b902.svg";
export { ForwardRef as ReactComponent };